import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';

interface CornerThumbProps {
  onToggle: () => void;
  children: ReactNode;
  height?: ResponsiveStyleValue<number | string>;
  width?: ResponsiveStyleValue<number | string>;
  bottom?: number | string;
  right?: number | string;
}

/** The small corner overlay (map or photo) */
const CornerThumb = ({
  onToggle,
  children,
  height = 90,
  width = 130,
  bottom = 0,
  right = 0,
}: CornerThumbProps) => {
  return (
    <Box
      onClick={onToggle}
      sx={{
        '&:hover': {
          transform: 'scale(1.04)',
        },
        border: '2px solid white',
        borderRadius: 2,
        bottom,
        boxShadow: 3,
        cursor: 'pointer',
        height,
        overflow: 'hidden',
        position: 'absolute',
        right,
        transition:
          'transform 0.2s, bottom 0.3s ease-in-out, right 0.3s ease-in-out',
        width,
        zIndex: 1,
      }}
    >
      {children}
    </Box>
  );
};

export default CornerThumb;
